/**
 * Delays completion of promise until threshold of {ms} is reached
 *
 * @template T
 * @param {number} ms Number of ms to delay promise completion
 * @param {Promise<T>} promise The promise to delay
 * @return {Promise<T>}
 */
export function delayPromise(ms, promise) {
    const start = Date.now();

    return promise.then((result) => {
        const diff = Date.now() - start;
        console.log("delayPromise diff", diff, ms - diff);

        if (diff > ms) return result;

        return new Promise((res, rej) => {
            setTimeout(() => {
                res(result);
            }, ms - diff);
        });
    });

}
